import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProductKpiService {
  constructor(private http: HttpClient) {}

  getAvgRemaingLifetimePerProduct() {
    return this.http.get(
      environment.apiUrl + "/api/statistics/lifecycle-delta-per-product"
    );
  }

  getAvgTurnaroundTimePerProductType(
    period?: string,
    start?: string,
    end?: string,
    customer?: string
  ) {
    let p = {
      period: period ? period : "This year",
      customer: customer ? customer : null,
    };

    if (start) {
      p["start"] = start;
    }

    if (end) {
      p["end"] = end;
    }

    return this.http.get(
      environment.apiUrl + "/api/statistics/avg-turnaround-time-per-product",
      { params: p }
    );
  }

  getGroupedCycleCount() {
    return this.http.get(
      environment.apiUrl + "/api/statistics/grouped-avg-cycle-count"
    );
  }

  getAvgCycleCountByProduct() {
    return this.http.get(
      environment.apiUrl + "/api/statistics/avg-cycle-count-by-product"
    );
  }

  getDeliveredProductsInPeriod(period?: string, start?: string, end?: string) {
    const now = new Date(); // Current date and time
    let startDate: Date;
    let endDate: Date;
    const fakeData = { data: [] };

    // Determine the date range based on the timeSelection
    switch (period) {
      case "This week":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;
      case "Since 2 weeks":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;

      case "This month":
        startDate = new Date(now.getFullYear(), now.getMonth(), 1); // First day of the current month
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of the current month
        fakeData.data = this.generateWeeklyData(startDate, endDate);
        break;

      case "Last month":
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1); // First day of last month
        endDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of last month
        fakeData.data = this.generateWeeklyData(startDate, endDate);
        break;

      case "This year":
        startDate = new Date(now.getFullYear(), 0, 1); // First day of the current year
        endDate = new Date(now.getFullYear(), 11, 31); // Last day of the current year
        fakeData.data = this.generateMonthlyData(startDate, endDate);
        break;

      case "Last year":
        startDate = new Date(now.getFullYear() - 1, 0, 1); // First day of last year
        endDate = new Date(now.getFullYear() - 1, 11, 31); // Last day of last year
        fakeData.data = this.generateMonthlyData(startDate, endDate);
        break;

      default:
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;
    }

    console.log("Generated Data:", fakeData);
    return of(fakeData); // Simulate an observable
  }

  getReturnedProductsInPeriod(period?: string, start?: string, end?: string) {
    const now = new Date(); // Current date and time
    let startDate: Date;
    let endDate: Date;
    const fakeData = { data: [] };

    // Determine the date range based on the timeSelection
    switch (period) {
      case "This week":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;
      case "Since 2 weeks":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;

      case "This month":
        startDate = new Date(now.getFullYear(), now.getMonth(), 1); // First day of the current month
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of the current month
        fakeData.data = this.generateWeeklyData(startDate, endDate);
        break;

      case "Last month":
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1); // First day of last month
        endDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of last month
        fakeData.data = this.generateWeeklyData(startDate, endDate);
        break;

      case "This year":
        startDate = new Date(now.getFullYear(), 0, 1); // First day of the current year
        endDate = new Date(now.getFullYear(), 11, 31); // Last day of the current year
        fakeData.data = this.generateMonthlyData(startDate, endDate);
        break;

      case "Last year":
        startDate = new Date(now.getFullYear() - 1, 0, 1); // First day of last year
        endDate = new Date(now.getFullYear() - 1, 11, 31); // Last day of last year
        fakeData.data = this.generateMonthlyData(startDate, endDate);
        break;

      default:
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;
    }

    console.log("Generated Data:", fakeData);
    return of(fakeData); // Simulate an observable
  }

  getIncomingOutgoingProductsInPeriod(timeSelection?: string): Observable<any> {
    const now = new Date(); // Current date and time
    let startDate: Date;
    let endDate: Date;
    const fakeData = { data: [] };

    // Determine the date range based on the timeSelection
    switch (timeSelection) {
      case "This week":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;
      case "Since 2 weeks":
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;

      case "This month":
        startDate = new Date(now.getFullYear(), now.getMonth(), 1); // First day of the current month
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of the current month
        fakeData.data = this.generateWeeklyData(startDate, endDate);
        break;

      case "Last month":
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1); // First day of last month
        endDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of last month
        fakeData.data = this.generateWeeklyData(startDate, endDate);
        break;

      case "This year":
        startDate = new Date(now.getFullYear(), 0, 1); // First day of the current year
        endDate = new Date(now.getFullYear(), 11, 31); // Last day of the current year
        fakeData.data = this.generateMonthlyData(startDate, endDate);
        break;

      case "Last year":
        startDate = new Date(now.getFullYear() - 1, 0, 1); // First day of last year
        endDate = new Date(now.getFullYear() - 1, 11, 31); // Last day of last year
        fakeData.data = this.generateMonthlyData(startDate, endDate);
        break;

      default:
        startDate = new Date(now);
        startDate.setDate(now.getDate() - now.getDay()); // Start of the week (Sunday)
        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // End of the week (Saturday)
        fakeData.data = this.generateDailyData(startDate, endDate);
        break;
    }

    console.log("Generated Data:", fakeData);
    return of(fakeData); // Simulate an observable
  }

  generateDailyData(startDate: Date, endDate: Date): any[] {
    const dates: string[] = [];
    const current = new Date(startDate);

    while (current <= endDate) {
      dates.push(current.toLocaleDateString()); // Format as needed
      current.setDate(current.getDate() + 1); // Increment by one day
    }

    return dates.map((date) => ({
      name: date, // Use the formatted date here
      series: [
        { name: "Incoming", value: Math.floor(Math.random() * 200) },
        { name: "Outgoing", value: Math.floor(Math.random() * 200) },
      ],
    }));
  }

  generateWeeklyData(startDate: Date, endDate: Date): any[] {
    const weeks: string[] = [];
    let currentWeekStart = new Date(startDate);
    let weekCounter = 1;

    while (currentWeekStart <= endDate) {
      const weekLabel = `Week ${weekCounter++}`;
      weeks.push(weekLabel);

      // Move to the next week
      currentWeekStart.setDate(currentWeekStart.getDate() + 7);
    }

    return weeks.map((week) => ({
      name: week, // Week label
      series: [
        { name: "Incoming", value: Math.floor(Math.random() * 200) },
        { name: "Outgoing", value: Math.floor(Math.random() * 200) },
      ],
    }));
  }

  generateMonthlyData(startDate: Date, endDate: Date): any[] {
    const months: string[] = [];
    const current = new Date(startDate);

    while (current <= endDate) {
      const monthLabel = `${current.getMonth() + 1}/${current
        .getFullYear()
        .toString()
        .slice(-2)}`; // Format as MM/YY
      months.push(monthLabel);

      // Move to the next month
      current.setMonth(current.getMonth() + 1);
    }

    return months.map((month) => ({
      name: month, // Month label
      series: [
        { name: "Incoming", value: Math.floor(Math.random() * 200) },
        { name: "Outgoing", value: Math.floor(Math.random() * 200) },
      ],
    }));
  }

  // getIncomingOutgoingProductsInPeriod(period?: string, start?: string, end?: string) {

  //   let p = {
  //     'period': period ? period : 'Since 2 weeks',
  //   };

  //   if (start) {
  //     p['start'] = start;
  //   }

  //   if (end) {
  //     p['end'] = end;
  //   }

  //   return this.http.get(environment.apiUrl + '/api/statistics/incoming-outgoing-products', {params: p});
  // }

  getProductTypes(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/products`);
  }
}
